import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	container: {
		textAlign: 'center',
		paddingTop: theme.spacing(12)
	},
	icon: {
		fontSize: '5rem',
		marginBottom: theme.spacing(2)
	},
	title: {
		marginBottom: theme.spacing(2.5)
	},
	message: {
		maxWidth: 600,
		marginBottom: theme.spacing(6)
	}
}));
